import { useQuery } from '@apollo/client';
import { GET_PA_DOCUMENT } from 'graphql/queries';
import { useEffect, useState } from 'react';

export const PractitionerUpdatePaViewModel = (id: string) => {
  const [formDetails, setFormDetails] = useState<any>();
  const { data, loading } = useQuery(GET_PA_DOCUMENT, {
    variables: {
      getPaDocumentInput: {
        id,
      },
    },
  });

  useEffect(() => {
    if (data) {
      setFormDetails(data?.getPaDocument);
    }
  }, [data]);

  // eslint-disable-next-line no-console
  console.log(formDetails);

  return {
    formDetails,
    data,
    loading,
  };
};
